// extracted by mini-css-extract-plugin
export default {"feedBack":"Nodes_feedBack__vVU+2"};